module.exports = __webpack_public_path__ + "static/pricing-policy-1.847bd557.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pricing_policy/pricing-policy-1.svg
// module id = 286
// module chunks = 232153529667241 277036910692064